<template>
  <div class="bottom-btn">
		<button @click="addToCart">Next</button>
		<div class="download pcShow" @click="createPdf">Download<a-icon type="cloud-download" /></div>
	</div>
</template>

<script>
export default {
  methods: {
    addToCart () {
      // 问卷结果页next 埋点
      this.$sensors.track('ClickQuestionnaireResult', {
        email: this.$store.state.userEmail,
        source: 'Next'
      })

      const url = 'https://life.femometer.com/collections/all-product'
      if(this.$store.state.product.length > 0){
        let params = '?add_cart='
        this.$store.state.product.forEach(prodtctId => {
          params += prodtctId + '_'
        });
        params = params.slice(0, -1)
        window.location.href = url + params
      }else{
        window.location.href = url
      }
    },
		createPdf () {
      // 问卷结果页download 埋点
      this.$sensors.track('ClickQuestionnaireResult', {
        email: this.$store.state.userEmail,
        source: 'Download'
      })

			this.$router.push('/pdf')
		}
	}
}
</script>

<style lang="less" scoped>
@media only screen and (max-width: 767px) {
	
	.bottom-btn {
    position: absolute;
		cursor: pointer;
    bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
		button {
      border: none;
      width: 225px!important;
      height: 45px!important;
      background: #E26CA5;
      border-radius: 36px;
      font-size: 17px;
      font-family: Helvetica-Bold, Helvetica;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 20.5px;
    }
    .download {
      margin-top: 12.5px;
      font-size: 13px!important;
      font-family: Helvetica;
      color: #989898;
      line-height: 15.5px;
      text-decoration:underline;
    }
  }
}
@media only screen and (min-width: 767px) {
	.bottom-btn {
		margin-top: 38px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: space-between;
		button {
			border: none;
			// position: relative;
			// margin-top: 63px;
			// padding-top: 108;
			width: 360px;
			height: 70px;
			background: #E26CA5;
			border-radius: 72px;
			font-size: 17px;
			font-family: Helvetica-Bold, Helvetica;
			font-weight: bold;
			color: #FFFFFF;
			line-height: 20.5px;
		}
		.download {
			// margin-top: 12.5px;
			font-size: 23px;
			text-decoration:underline;
			font-family: Helvetica;
			color: #989898;
			line-height: 15.5px;
		}
	}
}
</style>